
<div class="flex flex-col items-centered shrink-0 relative group" [class]="sizeClass">
  @if (imgUrl) {
    <img class="rounded-full " [class]="classes" [src]="imgUrl">
  }

  @if (!imgUrl) {
    <div class="rounded-full surface-container-highest flex flex-row justify-center items-center" [class]="classes">
      <h4 class="font-gamer" [class]="initialsClass" >{{initials}}</h4>
    </div>
  }

</div>


